import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetImprovementDetail  {
    _originalTypeClassName = "zERP.BO.AssetImprovementDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetImprovementDetail.translate = translateService;
}
this.Document = [];
this.Id = null;
this.DocumentDepreciationStartDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DocumentDepreciationStartDate:any;
SubAsset:any;
Document:any;
static setSubAsset = ($this, value) => {
var oldValue = $this.SubAsset;
$this.SubAsset = value;
if (value != null) {
}
}
static setDocument = ($this, items) => {
                if (items == null) items = [];
                if ($this.Document == null) $this.Document = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Document.length > 0) {
                    Domain.AssetImprovementDetail.removeDocument($this, $this.Document[0]);
                }

                Domain.AssetImprovementDetail.addManyDocument($this, copyItems);
            }
static addManyDocument = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetImprovementDetail.addDocument($this, items[i]);
                }
            }
static addDocument = ($this, item) => {
                if ($this.Document == null) $this.Document = [];
                if (item == null || $this.Document.indexOf(item) > -1) return;
                $this.Document.push(item);
}
static addRangeDocument = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetImprovementDetail.addDocument($this, item));
            }
static removeDocument = ($this, item) => {
                if ($this == null || $this.Document == null || $this.Document.indexOf(item) === -1) return;
                var _index = $this.Document.indexOf(item);
                $this.Document.splice(_index, 1);
}
static clearDocument = ($this) => { $this.Document = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}